import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthenticatedResponse, LoginNModel } from '../../components/Login/pro-view-login/pro-view-login.component';
@Injectable({
  providedIn: 'root'
})

export class LoginService {
  private LoginValidationUrl: string;
  private testurl: string;
  private _baseUrl: string;
  private SetSessionUrl: string;
  router: Router;

  constructor(private http: HttpClient) {//, @Inject('APP_BASE_HREF') private baseUrl: string) {
    this.LoginValidationUrl = "/LoginPage/Login";
    this.SetSessionUrl = "/LoginPage/SetSessiondata";
    this.testurl = "/Authenticate/TestMethodfortokenvalidation";
    this._baseUrl = ""; 
  }
  public getLoginValidation(userName: string, passWord: string): Observable<any> {
    let model = new LoginModel();
    model.Username = userName;
    model.Password = passWord;
    return this.http.post<any>(this._baseUrl + this.LoginValidationUrl, model);
  }
  public SetSession(userObj: string) {
    let params = new HttpParams();
    params.set("userObj", userObj)
    let model = new TokenResult();
    return this.http.post<any>(this._baseUrl + "/LoginPage/SetSessiondata?userObj=" + userObj, model);
  }
  public LogoutUser(logoutUser) {
    return this.http.post<any>(this._baseUrl + "/LoginPage/LogoutUser", logoutUser);
  }
  public deleteSession() {
    return this.http.post(this._baseUrl + "/LoginPage/DeleteSession", "", { responseType: 'text' });
  }
  getEntitlement() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetEntitlement");
  }
  GetAllLoggedInUsers() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetAllLoggedInUsers");
  }
  getValidationError() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetValidationMessage");
  }
  getSession() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetSessiondata");
  }

  ValidateLogin(code: any) {
    return this.http.get<any>(this._baseUrl + "/LoginPage/ValidateLogin?code=" + code);
  }
  ValidateAAALogin(code: any) {
    return this.http.get<any>(this._baseUrl + "/LoginPage/ValidateAAALogin?code=" + code);
  }
  getSiteKey() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/getSiteKey");
  }
  verifyReCaptcha(token: any) {
    return this.http.get<any>(this._baseUrl + "/LoginPage/VerifyCaptcha?captchaToken=" + token);
  }

  getlogo() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GarsLogo");
  }
  getlogoutURL(baseUrl: any) {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetLogoutURL?baseUrl=" + baseUrl);
  }
  getLoginFailedAttempts() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetLoginfailureAttempts");
  }

  getPDFBackupEnableFlag() {
    return this.http.get(this._baseUrl + "/LoginPage/GetDRPDFBackupFlag", { responseType: 'text' });
  }
  public gettest(str: string): Observable<any> {
    let params = new HttpParams();
    params = params.set("test", str);
    return this.http.get<any>(this._baseUrl + this.testurl, { params: params });
  }
  //redirecttoSSO(username: string) {
  //  let params = new HttpParams();
  //  params = params.set("username", username);
  //  return this.http.get<any>(this._baseUrl + "/LoginPage/GetAuthorizationModel", { params: params });
  //}
  validateBasicView() {
    return this.http.post<AuthenticatedResponse>(this._baseUrl + "/LoginPage/loginBasicView", {
      headers: new HttpHeaders({ "Content-Type": "application/json" })
    })
  }
  validateCreds(creds: LoginNModel) {
    return this.http.post<AuthenticatedResponse>(this._baseUrl + "/LoginPage/login", creds, {
      headers: new HttpHeaders({ "Content-Type": "application/json" })
    })
  }
  generatetoken(code: string) {
    let params = new HttpParams();
    params = params.set("code", code);
    return this.http.get<any>(this._baseUrl + "/LoginPage/GenerateToken", { params: params });
  }
  refreshtoken(token: string) {
    let params = new HttpParams();
    params = params.set("refreshtoken", token);
    return this.http.get<any>(this._baseUrl + "/LoginPage/Refreshtoken", { params: params });
  }
}
export class LoginModel {
  Username: string
  Password: string
  RefreshToken: string
}
export class TokenResult {
  AccessToken: string

  IdToken: string
  TokenType: string
  NotBefore: number;
  ExpiresIn: number;
  ExpiresOn: number;
  Resource: any;
  IdTokenExpiresIn: number;
  ProfileInfo: string
  Scope: any
  RefreshToken: string
  RefreshTokenExpiresIn: number;
}
